// eslint-disable-next-line import/prefer-default-export
export const COMPANY_NAVBAR_OFFSET = -120;
